export default __webpack_public_path__ + "static/media/FarmingPick Delayed.6044f617.wav";